<template>
  <v-popover
    :content-class="'black-tooltip'"
    placement="bottom"
    class="square-icon-wrap h-w-32 header-icon public-page-button"
    :on-show="() => !isMobile"
  >
    <div
      class="flex justify-center items-center h-full electron-no-drag"
      @click="openPublicPageInNewTab"
    >
      <em
        class="custom-icons public-page-icon"
        :style="getCustomIconStyle(iconPath('globe'))"
      />
      <span
        v-if="!isMobile"
        class="public-page-text ml-1"
        >{{ translate('shared') }}</span
      >
    </div>

    <template #content>
      <div class="flex items-center">
        <span class="font-medium">{{ translate('openSharedPage') }}</span>
        <em
          :style="getCustomIconStyle(iconPath('external-link'))"
          class="custom-icons bg-white ml-2"
        />
      </div>
    </template>
  </v-popover>
</template>

<script>
import getDashedTitle from '@/utilities/getDashedTitle';
import customIconsMixin from '@/mixins/customIconsMixin';

export default {
  name: 'PublicPageButton',

  mixins: [customIconsMixin],

  computed: {
    page() {
      return this.$store.getters.getPage;
    },
  },

  methods: {
    openPublicPageInNewTab() {
      const dashedPageTitle = getDashedTitle(this.page.title);
      const publicUrl = this.page.public_settings?.url
        ? `${this.page.public_settings?.url}-${dashedPageTitle}`
        : '';
      window.open(publicUrl, '_blank');
    },
  },
};
</script>

<style lang="scss">
.mobile {
  .public-page-button {
    @apply h-6 w-6 #{!important};
  }
}
</style>
